import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getContext, getLocation } from '../../redux/spaces-slice';
import { formatLocalizedDate, formatLocalizedTime, } from '../../../../utils/locale-format';
function useTime() {
    const [date, setDate] = useState(new Date()); // Save the current date to be able to trigger an update
    const location = useSelector(getLocation);
    const contextInfo = useSelector(getContext);
    const { i18n } = useTranslation();
    const locale = i18n.resolvedLanguage || i18n.language;
    const timeZone = contextInfo.timeZoneId;
    const dateLabel = formatLocalizedDate(date, locale, timeZone);
    const time = formatLocalizedTime(date, locale, timeZone, (location === null || location === void 0 ? void 0 : location.use24HrClockStyle) === true);
    useEffect(() => {
        const interval = setInterval(() => {
            setDate(new Date());
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    return { time, dateLabel };
}
export default useTime;
